import throttle from 'lodash/throttle';
import isNil from 'lodash/isNil';
import negate from 'lodash/negate';
import isFunction from 'lodash/isFunction';

const isNotAFunction = negate(isFunction);

const SCROLL_THROTTLE_TIME = 100;  // ms
const INFINITY_SCROLL_GAP  = 300;  // px

export default {
   beforeMount() {
      this.$nextTick(() => {
         if ( isNil(this.selectedWrapper) || isNil(this.hasNextPage) || isNotAFunction(this.loadNextPage) ) {
            throw new Error('Incorrect using mixin');
         }

         this._addInfinityScrollListener();
      });
   },
   methods: {
      scrollListener: throttle(function _listener(event) {
         // eslint-disable-next-line no-invalid-this
         if (!this.hasNextPage) {
            return;
         }

         let st, ch, sh;
         const container = event.target;
         if (container === document) {
            st = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
            sh = document.body.scrollHeight;
            ch = window.innerHeight;
         } else {
            st = container.scrollTop;
            ch = container.clientHeight;
            sh = container.scrollHeight;
         }

         if (sh - st - ch < INFINITY_SCROLL_GAP) {
            // eslint-disable-next-line no-invalid-this
            this.loadNextPage();
         }
      }, SCROLL_THROTTLE_TIME),
      _addInfinityScrollListener() {
         this.selectedWrapper.addEventListener('scroll', this.scrollListener);
      },
      _removeInfinityScrollListener() {
         this.selectedWrapper.removeEventListener('scroll', this.scrollListener);
      }
   },
   beforeDestroy() {
      this._removeInfinityScrollListener();
   }
};
